var _rect, _rect2, _rect3, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPromotePopupBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 570,
    height: 204,
    viewBox: "0 0 570 204",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 780,
    height: 206,
    fill: "#84CFCB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 780,
    height: 206,
    fill: "url(#paint0_radial_1_1597)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 780,
    height: 206,
    fill: "url(#paint1_radial_1_1597)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M702.915 59.034C652.531 56.2275 529.702 38.4346 445.548 81.321C364.075 122.841 112.594 224.619 -114.648 227.918L-137 227.918C-129.58 228.028 -122.127 228.026 -114.648 227.918L707 227.918L702.915 59.034Z",
    fill: "url(#paint2_linear_1_1597)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M326.926 101C470.783 101 624.523 155.92 697 168.452L697 216L-131 216L-131 200.519C11.7586 199.966 183.069 101 326.926 101Z",
    fill: "url(#paint3_linear_1_1597)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1_1597",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(280.311 216.764) rotate(-74.754) scale(241.526 408.154)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAEEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84CFCB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1_1597",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(444.386 -9.44165) rotate(91.3678) scale(221.722 390.349)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4E9E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84CFCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_1597",
    x1: 285.777,
    y1: 85.2368,
    x2: 280.658,
    y2: 301.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_1597",
    x1: 283,
    y1: 101,
    x2: 283,
    y2: 205.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotePopupBackground);
export default __webpack_public_path__ + "static/media/promote_popup_background.301ce785bde65be3649821739fb873ad.svg";
export { ForwardRef as ReactComponent };